/**
 * Reject/Flag Reason Modal
 *
 * Prompts admin for a required reason when rejecting or flagging a review.
 *
 * Story: SCRUM-840
 */

import React, { useState } from 'react';
import Modal from '../shared/Modal';

export default function RejectReasonModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Reject Review',
  actionLabel = 'Reject',
  loading = false,
}) {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    if (!reason.trim()) {
      setError('Reason is required');
      return;
    }
    try {
      setError(null);
      await onConfirm(reason.trim());
      setReason('');
      onClose();
    } catch (err) {
      setError(err.message || 'Action failed');
    }
  };

  const handleClose = () => {
    setReason('');
    setError(null);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      footer={
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading || !reason.trim()}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50"
          >
            {loading ? 'Processing...' : actionLabel}
          </button>
        </div>
      }
    >
      <div className="space-y-3">
        <label htmlFor="moderation-reason" className="block text-sm font-medium text-gray-700">
          Reason (required)
        </label>
        <textarea
          id="moderation-reason"
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason for this action..."
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
        />
        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}
      </div>
    </Modal>
  );
}
